import React from 'react';
import PropTypes from 'prop-types';
import '../../../styles/RailsLandingFooter.css';

const RailsLandingContent = ({ railsLandingContent }) => {
  const landingContent = railsLandingContent?.map((item) => {
    return (
      <li className="contentItem">
        <h2 className="contentHeading">{item.title}</h2>
        <p className="contentDescription">{item.description}</p>
      </li>
    );
  });

  return (
    <div className="railsLandingContent">
      <ul className="appendBottom15">{landingContent}</ul>
    </div>
  );
};

RailsLandingContent.propTypes = {
  railsLandingContent: PropTypes.array.isRequired
};

export default RailsLandingContent;
